import { Component } from "react";

// Catches render crashes (e.g. browser auto-translate 'removeChild' errors) on payment result pages
export class PaymentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Payment page error:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div translate="no" className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg border border-slate-200 p-8 text-center" data-testid="payment-error-fallback">
          <h1 className="text-xl font-semibold text-slate-900 mb-2">Please refresh to confirm your payment</h1>
          <p className="text-sm text-slate-600 mb-1">Your payment may already be complete. Refreshing will show its latest status.</p>
          <p className="text-sm text-slate-500 mb-6">Ödemenizi onaylamak için lütfen sayfayı yenileyin.</p>
          <button
            onClick={() => window.location.reload()}
            className="w-full rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2.5 transition-colors"
            data-testid="payment-error-refresh-btn"
          >
            Refresh page
          </button>
          <a href="/student-dashboard" className="block mt-3 text-sm text-emerald-700 hover:underline" data-testid="payment-error-portal-link">
            Go to my dashboard
          </a>
        </div>
      </div>
    );
  }
}
